import React from "react";
import SharedHelmet from "../Helmet";
import SYFlag from "./sy.svg";
import SAFlag from "./sa.svg";
import EGFlag from "./eg.svg";
import JOFlag from "./jo.svg";
const TITLE = "حاسبات الدول المختلفة";
const DESCRIPTION = "يقدم موقعنا مجموعة واسعة من الحاسبات الآلية المصممة خصيصًا لتلبية احتياجات مختلف الدول...";
const KEYWORDS = "حاسبات، دول، سعودية، سورية، سوريا، السعودية";
const OG_URL = "https://do-calculate.com/calculator/ar/countries/";
const countries = {
  SY: "سورية",
  SA: "السعودية",
  EG: "مصر",
  JO: "الأردن",
};
const countryFlags = {
  SY: SYFlag,
  SA: SAFlag,
  EG: EGFlag,
  JO: JOFlag,
};
const COUNTRIES = Object.keys(countries);
function CountriesList() {
  const renderCountryGrid = (parameters, parameterData) => (
    <div className="country-grid">
      {parameters.map((fromParams) => (
        <a
          key={fromParams}
          href={`/calculator/ar/countries/${fromParams}/calculators-list`}
          className="country-item"
        >
          <div className="flag-container">
            <img
              src={countryFlags[fromParams]}
              alt={`${parameterData[fromParams]} flag`}
              width="32"
              height="24"
            />
          </div>
          <span className="country-name">{parameterData[fromParams]}</span>
        </a>
      ))}
    </div>
  );
  return (
    <div>
      <div className="container rtl-container">
        <SharedHelmet
          TITLE={TITLE}
          DESCRIPTION={DESCRIPTION}
          KEYWORDS={KEYWORDS}
          OG_URL={OG_URL}
        />
        <div>
          <h1 style={{ fontSize: "26px" }}>{TITLE}</h1>
          <hr />
          <div className="alert alert-secondary" role="alert">
            <p>{DESCRIPTION}</p>
          </div>
        </div>
        <hr />
        <h2>البلدان</h2>
        {renderCountryGrid(COUNTRIES, countries)}
        <br />
      </div>
      <style>
        {`
          .country-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
            gap: 20px;
            text-align: center;
          }
          .country-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-decoration: none;
            color: black;
            padding: 20px;
            background: white;
            border-radius: 10px;
            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
            cursor: pointer;
          }
          .flag-container {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 64px;
            height: 64px;
            background-color: #f7f7f7;
            border-radius: 50%;
            margin-bottom: 10px;
          }
          .flag-container img {
            border-radius: 4px;
          }
          .country-name {
            font-size: 14px;
            font-weight: 500;
            color: #333;
          }
          .country-item:hover {
            background-color: #f0f0f0;
            transform: translateY(-2px);
            transition: transform 0.2s ease, background-color 0.2s ease;
          }
        `}
      </style>
    </div>
  );
}
export default CountriesList;